import { Injectable, inject } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ContactFormGroup } from './contact-form-group.interface';
import { phoneNumberValidator } from '../../validators/phone-number-validator';

@Injectable()
export class ContactFormModel {
  readonly fieldNames = {
    name: 'name',
    surname: 'surname',
    position: 'position',
    birthDate: 'birthDate',
    phoneNumber: 'phoneNumber',
    email: 'email',
    responsibleUserId: 'responsibleUserId',
    organizationId: 'organizationId',
    isCustomer: 'isCustomer',
    isVendor: 'isVendor',
    contactType: 'contactType',
  };

  form: FormGroup<ContactFormGroup>;

  constructor() {
    const formBuilder = inject(FormBuilder);

    this.form = formBuilder.group<ContactFormGroup>({
      name: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(128)],
      }),
      surname: new FormControl(null, Validators.maxLength(128)),
      position: new FormControl(null, Validators.maxLength(128)),
      birthDate: new FormControl<string | null>(null),
      phoneNumber: new FormControl<string | null>(null, {
        validators: [phoneNumberValidator],
      }),
      email: new FormControl(null, [Validators.email]),
      responsibleUserId: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required],
      }),
      organizationId: new FormControl(null),
      isCustomer: new FormControl(false, { nonNullable: true }),
      isVendor: new FormControl(false, { nonNullable: true }),
      contactType: new FormControl({ isCustomer: false, isVendor: false }, { nonNullable: true }),
    });
  }
}
